<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      append-to-body
      width="780px"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <editForm
        ref="editForm"
        :tripReimbursementReportDocCode="tripReimbursementReportDocCode"
        @close="close()"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.editForm.save()">
          {{ $l('INDEX.btn_upload') || '上传' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import editForm from './index.vue'
export default {
  components: {editForm},
  props: {
    title: {type: String, default: ''},
    visible: {type: Boolean, default: false},
    tripReimbursementReportDocCode: {type: String, default: ''},
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
